import type { UseQueryResult } from '@tanstack/react-query';
import { isRegistered } from '../../contexts/utils/customer-utils';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useCustomerGet } from './useCustomerGet';
import type { CustomerProductList } from './model';

export const useSaveForLater = (): UseQueryResult<CustomerProductList> => {
    const { data } = useCustomerGet();

    return useBffGet(
        ({ customer_id }) => `/customers/${customer_id}/save-for-later`,
        [],
        [BffQueryKey.CUSTOMER_SAVE_FOR_LATER],
        { enabled: isRegistered(data) },
    );
};
